module.exports = __webpack_public_path__ + "img/iripple-logo-black.5b47c849.png";